<template>
  <div class="block_wrap">
    <div class="connected_roles">
      <p class="top">
        {{ translate("user.role_manage.connected_roles") }}
        ({{Object.keys(all_roles_list.connected_roles).length}})
      </p>
      <TableRole
          class="body"
          v-if="all_roles_list.connected_roles"
          :user_id="user_id"
          :role_list="all_roles_list.connected_roles"
          :permission_list="permission_list"
          @update="get_user_roles"
      />
    </div>
    <div class="available_roles" v-if="$store.getters.getPermissions.permissionGod === true">
      <p class="top">
        {{ translate("user.role_manage.available_roles") }}
        ({{Object.keys(all_roles_list.available_roles).length}})
      </p>
      <TableRole
          class="body"
          v-if="all_roles_list.available_roles"
          :user_id="user_id"
          :role_list="all_roles_list.available_roles"
          :permission_list="permission_list"
          @update="get_user_roles"
      />
    </div>
  </div>
</template>
<script>

import TableRole from "./TableRole.vue";

export default {
  name: "UserRolesForm",
  props: ['user_id'],
  components:{
    TableRole
  },
  data () {
    return {
      user_roles: [],
      role_list: [],
      permission_list: []
    }
  },
  created(){
    this.get_all_roles_and_permissions()
    this.get_user_roles()
  },
  computed:{
    all_roles_list() {
      let available_roles = {}
      let connected_roles = {}
      Object.keys(this.role_list).forEach((role) => {
        if (this.user_roles.includes(role)) {
          connected_roles[role] = {...this.role_list[role], checked: true}
        } else {
          available_roles[role] = {...this.role_list[role], checked: false}
        }
      })
      return {
        available_roles: available_roles,
        connected_roles: connected_roles
      }
    },
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    get_all_roles_and_permissions(){
      this.$http.v1.getAllRoles((response) => {
        this.role_list = response.data.roles
        this.permission_list = response.data.permissions
      })
    },
    get_user_roles(){
      this.$http.v1.getUserRoles(this.user_id, (response) => {
        this.user_roles = Object.keys(response.data)
      })
    },
  }
}

</script>
<style lang='scss' scoped>
  .block_wrap{
    height: calc(100% - 10px);
  }
  .connected_roles,
  .available_roles{
    height: 50%;
    margin-bottom: 10px;
    .top{
      text-align: start;
      margin-bottom: 0;
      height: 25px;
    }
    .body{
      height: calc(100% - 25px);
    }
  }



</style>
